import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Landing from "./Landing";
import NotFound from "./NotFound";
import TourDetails from "./TourDetails";
import Checkout from "./pages/checkout/Checkout";
import { Post } from "./pages/post/Post";
function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/experience/:expId" element={<TourDetails />} />
      <Route path="/experience/:expId/checkout" element={<Checkout />} />
      <Route path="/checkout/success" element={<Post />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
